import { render, staticRenderFns } from "./AccountRequestModal.vue?vue&type=template&id=3932c24c&scoped=true&"
import script from "./AccountRequestModal.vue?vue&type=script&lang=js&"
export * from "./AccountRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountRequestModal.vue?vue&type=style&index=0&id=3932c24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3932c24c",
  null
  
)

export default component.exports